import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@beef/ui-kit';

import { getCatalogProductsErrorMessage } from 'store/ProductCatalog/products/selectors';
import { resetAllOptions } from 'store/ProductCatalog/filters/actions';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';

import Icon from './assets/catholms.svg';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/* eslint-disable react/prop-types */
function WarningMessage({ children, onClick, isMobile }) {
  return (
    <div className={cx('component', isMobile ? 'mobile' : '')}>
      <Icon className={cx('icon')} />
      <div className={cx('title')}>{children}</div>
      <div className={cx('button')}>
        <Button variant="tertiary" size={isMobile ? 's' : 'l'} type="button" onClick={onClick}>
          Сбросить фильтры
        </Button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  children: getCatalogProductsErrorMessage(state),
  isMobile: isScreenBelow640(state),
});

const mapDispatchToProps = {
  onClick: resetAllOptions,
};

const WarningMessageWidget = connect(mapStateToProps, mapDispatchToProps)(WarningMessage);

WarningMessageWidget.propTypes = {
  children: PropTypes.any,
  isMobile: PropTypes.bool,
  onClick: PropTypes.func,
};

export default WarningMessageWidget;
